import loadable from "@loadable/component";

export default loadable(() => import("./LeadFunnel"));
export const LeadFunnelModal = loadable(() => import("./LeadFunnelModal"));
